import { useCallback, useState } from 'react';
import { createContainer } from '../../../utils/container';
import { useLocalStorage } from '../../../hooks/internal/useLocalStorage';
import { DIALECT_WALLET_CONFIG_STORAGE_KEY } from './constants';
function useDialectWalletStatesHolder({ autoConnect = false, } = { autoConnect: false }) {
    const [walletConnected, setWalletConnected] = useState(false);
    const [connectionInitiated, setConnectionInitiated] = useState(autoConnect);
    const [localStorageHardwareWalletConfig, setLocalStorageHardwareWalletConfig,] = useLocalStorage(DIALECT_WALLET_CONFIG_STORAGE_KEY, {
        hardwareWalletEnabled: false,
    });
    const [hardwareWalletForced, setHardwareWalletForced] = useState(localStorageHardwareWalletConfig.hardwareWalletEnabled);
    const handleSetHardwareWalletForced = useCallback((valOrFunc) => {
        const newState = typeof valOrFunc === 'function'
            ? valOrFunc(hardwareWalletForced)
            : valOrFunc;
        setHardwareWalletForced(newState);
        setLocalStorageHardwareWalletConfig({
            hardwareWalletEnabled: newState,
        });
    }, [hardwareWalletForced, setLocalStorageHardwareWalletConfig]);
    const [isSigningFreeTransaction, setIsSigningFreeTransaction] = useState(false);
    const [isSigningMessage, setIsSigningMessage] = useState(false);
    const [isEncrypting, setIsEncrypting] = useState(false);
    return {
        walletConnected: {
            get: walletConnected,
            set: setWalletConnected,
        },
        connectionInitiatedState: {
            get: connectionInitiated,
            set: setConnectionInitiated,
        },
        hardwareWalletForcedState: {
            get: hardwareWalletForced,
            set: handleSetHardwareWalletForced,
        },
        isSigningFreeTransactionState: {
            get: isSigningFreeTransaction,
            set: setIsSigningFreeTransaction,
        },
        isSigningMessageState: {
            get: isSigningMessage,
            set: setIsSigningMessage,
        },
        isEncryptingState: {
            get: isEncrypting,
            set: setIsEncrypting,
        },
    };
}
export const DialectWalletStatesHolder = createContainer(useDialectWalletStatesHolder);
//# sourceMappingURL=index.js.map